import { Pie } from 'react-chartjs-2';
import { MACRO_COLORS, pieOptions, round } from '../../../config/chart-config';
import { darkenHex } from '../../../helpers';

const ENERGY_MACROS = ['Fett', 'Protein', 'Kolhydrater', 'Alkohol'];

const EnergyChart = ({ labels, values, singleChart = true, title }) => {

    if (!labels?.length || !values?.length) return null;

    const labelValueMap = labels.reduce((acc, label, i) => {
        acc[label] = values[i];
        return acc;
    }, {});

    const normalizedValues = ENERGY_MACROS.map((macro) => labelValueMap[macro] ?? 0);

    const colors = ENERGY_MACROS.map((macro) => MACRO_COLORS[macro] || '#fff');

    // CONFIG

    const data = {
        labels: ENERGY_MACROS.filter((label) => labelValueMap[label] !== undefined),
        datasets: [
            {
                data: normalizedValues.map(round),
                backgroundColor: colors,
                hoverBackgroundColor: colors.map((c) => darkenHex(c, 0.1))
            }
        ]
    };

    const options = {
        ...pieOptions,
        responsive: true,
        maintainAspectRatio: false,
        layout: { padding: 0 },
        plugins: {
            ...pieOptions.plugins,
            legend: {
                ...pieOptions.plugins.legend,
                labels: {
                    ...pieOptions.plugins.legend.labels,
                    padding: singleChart ? 35 : 25
                }
            }
        }
    };

    return (
        <div className={`chart-wrapper ${singleChart ? 'single-chart' : ''}`}>
            {!singleChart && <span>{title ?? 'Energi'}</span>}

            <div className="chart-inner">
                <Pie data={data} options={options} />
            </div>
        </div>
    );
};

export default EnergyChart;
